export default {
    items: [],
    assets_data: [],
    currency_chart_data: [],
    holding_data: [],
    quantity:0.0,
    currency:"USD",
    cash_symbols: [],
    stock_symbols: [],
}